import { useState } from "react";
import { useGetCardToUploadByUserIdQuery } from "../../../services/myServer/cardToUpload";
import { LoadingOverlay } from "../../common/LoadingOverley/LoadingOverley";
import { FiltersTable } from "../FiltersTable/FiltersTable";
import { TransactionCreateCards } from "./TransactionCreateCards";
import {
  CardToUploadStatusCardMarketEnum,
  CardToUploadStatusCardTraderEnum,
} from "magic-shared-types";
import { useSelector } from "react-redux";
import { selectGame } from "../../../store/slices/global";

export const SectionUploadCards = () => {
  const [page, setPage] = useState(1);
  const [statusCt, setStatusCt] = useState<
    CardToUploadStatusCardTraderEnum | undefined
  >(undefined);
  const [statusCm, setStatusCm] = useState<
    CardToUploadStatusCardMarketEnum | undefined
  >(undefined);
  const [name, setName] = useState("");
  const pageSize = 20;
  const game = useSelector(selectGame);

  const {
    data: cardToUploadData,
    isLoading: cardToUploadLoading,
    refetch,
  } = useGetCardToUploadByUserIdQuery(
    {
      page,
      pageSize,
      status_ct: statusCt || undefined,
      status_cm: statusCm || undefined,
      game_id: game.id,
      name,
    },
    { skip: !game }
  );

  if (cardToUploadLoading) {
    return <LoadingOverlay />;
  }
  return (
    <>
      <FiltersTable
        statusCt={statusCt}
        statusCm={statusCm}
        onStatusCtChange={setStatusCt}
        onStatusCmChange={setStatusCm}
        page={page}
        onPageChange={setPage}
        total={cardToUploadData?.pagination.total || 0}
        pageSize={pageSize}
        setName={setName}
      />
      {cardToUploadData && (
        <TransactionCreateCards
          data={cardToUploadData?.data}
          refetch={refetch}
        />
      )}
    </>
  );
};
